import { Patterns } from '@common/components/forms';

export const onKeyZipCodeValidation = (event: any) => {
  const zipRegEx = Patterns.zipCodeAny.value;
  const zipLength = event?.target.value.length;
  if (zipLength >= 5 || !zipRegEx.test(event.key)) {
    event.preventDefault();
  }
};

export const onKeyWholeNumberValidation = (event: any) => {
  const digitsRegEx = Patterns.integer.value;
  if (!digitsRegEx.test(event.key) || event.type == 'paste') {
    event.preventDefault();
  }
};

export const onKeyDecimalValidation = (event: any) => {
  const decimalRegEx = Patterns.decimal.value;
  if (!decimalRegEx.test(event.key) && event.key != '.') {
    event.preventDefault();
  }
};
